<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <div class="px-0 py-2">
        <v-card-title class="headline pl-4 py-2 pr-2">
          Nowy klient
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <div v-if="!dialogBusy">
          <div
            ref="scrollContainer"
            class="scrollable-height">
            <v-alert
              v-model="error"
              class="ma-0"
              dismissible
              type="error"
            >
              {{errorMsg}}
            </v-alert>
            <div class="py-4">
              <v-radio-group
                class="px-4 mt-0"
                v-model="formData.type"
                :error-messages="errors.collect('type')"
                v-validate="'required'"
                data-vv-name="type"
                data-vv-as="rodzaju konta"
                required
              >
                <v-layout wrap>
                  <v-flex v-for="(clientType, i) in clientTypes" :key="i" xs12 md6 pr-2>
                    <v-radio
                      color="primary"
                      :label="clientType.name"
                      :value="clientType.id"
                    ></v-radio>
                  </v-flex>
                </v-layout>
              </v-radio-group>

              <div class="px-4">
                <div class="body-2 grey--text">Dane użytkownika</div>
              </div>

              <div class="px-4">
                <v-text-field
                  v-model.trim="formData.name"
                  label="Nazwa klienta"
                  :error-messages="errors.collect('name')"
                  v-validate="'required|max:200'"
                  data-vv-name="name"
                  data-vv-as="nazwa klienta"
                  required
                ></v-text-field>
              </div>
              <div class="px-4" v-if="formData.type === 2">
                <v-text-field
                  v-model.trim="formData.nip"
                  label="NIP"
                  :error-messages="errors.collect('nip')"
                  v-validate="'required|min:10|numeric'"
                  data-vv-name="nip"
                  data-vv-as="NIP"
                  mask="##########"
                  required
                ></v-text-field>
              </div>
              <v-layout class="px-4">
                <v-flex xs8 pr-4>
                  <v-text-field
                    v-model.trim="formData.contact_address_city"
                    label="Miasto"
                    :error-messages="errors.collect('contact_address_city')"
                    v-validate="'max:50'"
                    data-vv-name="contact_address_city"
                    data-vv-as="miasto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model.trim="formData.contact_address_zip"
                    label="Kod pocztowy"
                    mask="##-###"
                    :error-messages="errors.collect('contact_address_zip')"
                    data-vv-name="contact_address_zip"
                    data-vv-as="kod pocztowy"
                    v-validate="'min:5|max:5|numeric'"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <div class="px-4">
                <v-text-field
                  v-model.trim="formData.contact_address_street"
                  label="Ulica i numer lokalu"
                  v-validate="'max:100'"
                  :error-messages="errors.collect('contact_address_street')"
                  data-vv-name="contact_address_street"
                  data-vv-as="ulica i numer lokalu"
                ></v-text-field>
              </div>
              <div class="px-4">
                <v-text-field
                  v-model.trim="formData.contact_phone_1"
                  label="Nr telefonu 1"
                  :error-messages="errors.collect('contact_phone_1')"
                  v-validate="'max:20|numeric'"
                  data-vv-name="contact_phone_1"
                  data-vv-as="nr telefonu 1"
                ></v-text-field>
              </div>
              <div class="px-4">
                <v-text-field
                  v-model.trim="formData.contact_phone_2"
                  label="Nr telefonu 2"
                  :error-messages="errors.collect('contact_phone_2')"
                  v-validate="'max:20|numeric'"
                  data-vv-name="contact_phone_2"
                  data-vv-as="nr telefonu 2"
                ></v-text-field>
              </div>

              <div class="px-4 pb-2">
                <v-text-field
                  v-model.trim="formData.contact_email"
                  label="Adres e-mail"
                  :error-messages="errors.collect('contact_email')"
                  v-validate="'max:250|email'"
                  data-vv-name="contact_email"
                  data-vv-as="e-mail"
                ></v-text-field>
              </div>

              <v-divider></v-divider>

              <div class="px-4 pt-4">
                <div class="body-2 grey--text">Dane adresowe</div>
              </div>
              <v-layout class="px-4">
                <v-flex xs8 pr-4>
                  <v-text-field
                    v-model.trim="formData.address_city"
                    label="Miasto"
                    :error-messages="errors.collect('address_city')"
                    v-validate="'max:50'"
                    data-vv-name="address_city"
                    data-vv-as="miasto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model.trim="formData.address_zip"
                    label="Kod pocztowy"
                    :error-messages="errors.collect('address_zip')"
                    mask="##-###"
                    data-vv-name="address_zip"
                    v-validate="'min:5|numeric'"
                    data-vv-as="kod pocztowy"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <div class="px-4 pb-2">
                <v-text-field
                  v-model.trim="formData.address_street"
                  label="Ulica i numer lokalu"
                  :error-messages="errors.collect('address_street')"
                  v-validate="'max:100'"
                  data-vv-name="address_street"
                  data-vv-as="ulica i numer lokalu"
                  required
                ></v-text-field>
              </div>


              <v-divider></v-divider>
              <div class="px-4 pt-4">
                <div class="body-2 grey--text">Kod PIN</div>
              </div>

              <div class="px-4">
                <v-text-field
                  v-model.trim="formData.pin"
                  label="PIN"
                  :error-messages="errors.collect('pin')"
                  :type="pinVisibility ? 'text' : 'password'"
                  :append-icon="pinVisibility ? 'visibility_off' : 'visibility'"
                  data-vv-name="pin"
                  v-validate="'required|max:10|min:6|alpha_num'"
                  @click:append="pinVisibility = !pinVisibility"
                  data-vv-as="pin"
                  required
                ></v-text-field>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="px-4 pt-4">
            <ServerErrors :errorsItems="serverErrors" />

            <v-spacer></v-spacer>

            <v-btn
              color="primary lighten-2"
              flat="flat"
              @click="setVisbility"
            >
              Anuluj
            </v-btn>

            <v-btn
              color="primary"
              :loading="busy"
              :disabled="busy"
              @click="storeClient"
            >
              Dodaj
            </v-btn>
          </v-card-actions>
        </div>
        <div v-if="dialogBusy">
          <div class="py-4 text-xs-center">
            <v-progress-circular
              :size="30"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getError } from '../../../helpers/helpers';
import { getAddFormData } from '../../../repository/clients/index';
import ServerErrors from '../../common/Errors/ServerErrors.vue';

export default {
  name: 'client-add-dialog',
  components: {
    ServerErrors,
  },
  data: () => ({
    pinVisibility: false,
    busy: false,
    dialogBusy: true,
    clients: null,
    roles: null,
    errorMsg: null,
    error: null,
    serverErrors: [],
    clientTypes: null,
    formData: {
      name: null,
      nip: null,
      pin: null,
      contact_address_city: null,
      contact_address_zip: null,
      contact_address_street: null,
      address_city: null,
      address_zip: null,
      address_street: null,
      contact_email: null,
      type: 1,
    },
  }),
  computed: {
    ...mapGetters('clients', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'add';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('clients', [
      'setDialogVisbility',
      'storeNewClient',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    getFormData() {
      this.getAddClientData();
    },
    clearData() {
      this.pinVisibility = false;
      this.busy = false;
      this.dialogBusy = true;
      this.clients = null;
      this.roles = null;
      this.errorMsg = null;
      this.error = null;
      this.clientTypes = null;
      this.nip = null;
      this.serverErrors = [];
      this.formData = {
        name: null,
        nip: null,
        pin: null,
        contact_address_city: null,
        contact_address_zip: null,
        contact_address_street: null,
        contact_email: null,
        address_city: null,
        address_zip: null,
        address_street: null,
        type: null,
      };
    },
    getServerErrors(errors) {
      const filedKeys = Object.keys(errors);
      filedKeys.forEach((fieldKey) => {
        const fieldErros = errors[fieldKey];
        if (!fieldErros[0] || fieldErros.length <= 0) return;
        fieldErros.forEach((err) => {
          const field = this.$validator.fields.find({
            name: fieldKey,
            scope: this.$options.scope,
          });
          if (field) {
            this.$validator.errors.add({
              id: field.id,
              field: fieldKey,
              msg: err,
              scope: this.$options.scope,
            });
            field.setFlags({
              invalid: true,
              valid: false,
              validated: true,
            });
          } else if (!this.serverErrors.includes(err)) {
            this.serverErrors.push(err);
          }
        });
      });
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
      this.$refs.scrollContainer.scrollTo(0, 0);
      if (errorData.response.data && errorData.response.data.data) {
        this.getServerErrors(errorData.response.data.data);
      }
    },
    async getAddClientData() {
      this.dialogBusy = true;
      try {
        const formRes = await getAddFormData();
        const formData = formRes.data.data;
        this.dialogBusy = false;
        this.clientTypes = formData.types;
      } catch (e) {
        this.getError(e);
      }
    },
    storeClient() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.addNewClient();
        }
      });
    },
    async addNewClient() {
      this.busy = true;
      try {
        if (this.formData.type !== 2) {
          this.formData.nip = null;
        }
        await this.storeNewClient(this.formData);
        this.busy = false;
        this.setDialogVisbility(false);
      } catch (e) {
        this.getError(e);
      }
    },
  },
  watch: {
    visibility(val, oldVal) {
      if (val === true) {
        this.getFormData();
      }
      if (oldVal) {
        this.clearData();
      }
    },
  },
};
</script>
